<template>
  <AtividadeCadastro
    :projetoSelecao="projetoSelecao"
    :atividadeSelecao="atividadeSelecao"
    @fechar-cadastro="$emit('fechar-cadastro', $event)"
    @atualizar-lista="$emit('atualizar-lista', $event)"
  />
</template>

<script>
import AtividadeCadastro from "./AtividadeCadastro.vue";

export default {
  name: "AtividadeFormulario",
  props: {
    projetoSelecao: {
      type: [Object, Array],
      default: null,
    },
    atividadeSelecao: {
      type: [Object, Array],
      default: null,
    },
  },
  components: {
    AtividadeCadastro,
  },
};
</script>
